import React, { useState, useEffect } from "react";
import useSendbirdStateContext from "@sendbird/uikit-react/useSendbirdStateContext";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GroupChannelHandler, HiddenChannelFilter, QueryType, ScheduledStatus } from '@sendbird/chat/groupChannel';
import { SENDBIRD_INFO } from "../../../utils/helpers/constant";
import { toastError } from "../../../utils/helpers/methods";
import Spinner from "../spinner";
import ChanneLItemPreview from "./chatItemPreview";
import { getMessageCount ,getAllMessage,getAssignedMessage} from "../../../redux/slices/notifications";
import ChatPagination from "../../ChatPagination";
import ChatHistory from "./chatHistory";
import { PatientListfilter } from "../../../redux/actions/passActions";
import MultiSelect from "../../MultiSelect";
import onMoveToPractice from "../../../utils/services/practice";
import { providersAssignChat } from "../../../utils/services/chat.service";
import { getChatFilterData, toggleChatDetail } from "../../../redux/slices/filter";

const limit = 100;

const ChanneListPreview = ({handleClose, activeTab, currentUser, handleChatView}) => {
  const store = useSendbirdStateContext();
  var sdk = store?.stores.sdkStore.sdk;
  const { doctorDetails } = useSelector((state) => state.auth)
  const { chatFilterData, isChatDetail } = useSelector((state) => state.filter)
  const [searchQuery, setSearchQuery] = useState("");
  const [scheduledMessageList, setScheduledMessageList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [isTeamOpen, setIsTeamOpen] = useState(false)
  const { userToken, userInfo } = useSelector((state) => state.auth)
  const {Patientfilter } = useSelector(
    (state) => {
      return state.pass
    }
  )
  const [PatientFilterval, setPatientFilterval] = useState({
    locations: [],
    team: ''
  });
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");
  const [practiceChannels, setPracticeChannels] = useState([]);
  const [assignedChannels, setAssignedChannels] = useState([]);
  const [archivedChannels, setArchivedChannels] = useState([]);
  const [isRestoringFilters, setIsRestoringFilters] = useState(false);

  useEffect(() => {
      if (!Patientfilter){
      dispatch(
        PatientListfilter({
          practitioner_id: userInfo.id,
          token: userToken,
        })
      )
      }    
  }, [])

  // useEffect(() => {
  //   if (!sdk || !sdk.groupChannel) {
  //     return
  //   }
  //   fetchScheduledMessages();
  //   activeTab === "tab2" ? fetchArchivedChannels() : fetchPracticeChannels();
  // }, [activeTab, sdk]);

useEffect(() => {
  if (!sdk || !sdk.groupChannel) return;
  
  if (isChatDetail && chatFilterData && chatFilterData.activeTab === activeTab) {
    setIsRestoringFilters(true);
    
    setSelectedLocations(chatFilterData.locations || []);
    setSelectedTeam(chatFilterData.team || '');
    setSearchQuery(chatFilterData.search || '');
    setPatientFilterval({
      locations: chatFilterData.locations || [],
      team: chatFilterData.team || ''
    });
    
    fetchScheduledMessages();
    
    const convertedLocations = chatFilterData.locations && chatFilterData.locations.length > 0 
      ? chatFilterData.locations.map(id => id.toString()) 
      : null;
    
    if (activeTab === "tab0") {
      fetchPracticeChannels(
        chatFilterData.search || null, 
        convertedLocations, 
        chatFilterData.team || null
      ).then(() => setIsRestoringFilters(false));
    }
    else if (activeTab === "tab1") {
      fetchAssignedChannels(
        chatFilterData.search || null, 
        convertedLocations, 
        chatFilterData.team || null
      ).then(() => setIsRestoringFilters(false));
    }
    else if (activeTab === "tab2") {
      fetchArchivedChannels(
        chatFilterData.search || null, 
        convertedLocations, 
        chatFilterData.team || null
      ).then(() => setIsRestoringFilters(false));
    }
    
    setTimeout(() => {
      dispatch(toggleChatDetail(false));
    }, 500);
  } else {
    fetchScheduledMessages();

    if (activeTab === "tab0") fetchPracticeChannels();
    else if (activeTab === "tab1") fetchAssignedChannels();
    else if (activeTab === "tab2") fetchArchivedChannels();
  }
}, [activeTab, sdk]);

  useEffect(() => {
    getChannel();
  }, [location]);

  useEffect(() => {
    const filterList=assignedChannels.filter((x) => x.data && parseDataForTab1(x))
    dispatch(getAssignedMessage(filterList));
  },[assignedChannels])

  useEffect(() => {
    activeTab === "tab0" && dispatch(getMessageCount(practiceChannels));
    dispatch(getAllMessage(practiceChannels));
  },[practiceChannels])

  const fetchScheduledMessages = async () => {
    let sendbird = sdk;
    var query = sendbird.groupChannel.createScheduledMessageListQuery({
      scheduledStatus:  [ScheduledStatus.PENDING],
      reverse:true,
      limit:100
    });
    if (query.hasNext) {
      var scheduledMessages = await query.next();
      if (scheduledMessages.length > 0) {
        setScheduledMessageList(scheduledMessages);
      }
      else {
        setScheduledMessageList([]);
      }
    } 
  }
  
  // const getChannel = async () => {
  //   let sendbird = sdk;
  //   const channelHandler = new GroupChannelHandler({
  //     onChannelHidden: (channel) => {
  //       activeTab === "tab2" ? setArchiveChannelList([]) : setChannelList([]);
  //       activeTab === "tab2" ? loadArchiveChannels() : fetchChannels();
  //     }, 
  //     onChannelChanged: (channel) => {
  //       activeTab === "tab2" ? setArchiveChannelList([]) : setChannelList([]);
  //       activeTab === "tab2" ? loadArchiveChannels() : fetchChannels();
  //     },
  //   });
  //   var handlerID = "channelList_care";

  //   sendbird?.groupChannel?.addGroupChannelHandler(handlerID, channelHandler);
  // };
  
 const getChannel = () => {
  let sendbird = sdk;
  const channelHandler = new GroupChannelHandler({
    onChannelHidden: () => {
      if (activeTab === 'tab0') {
       // setPracticeChannels([]);
        fetchPracticeChannels();
      }
      else if (activeTab === 'tab1'){  
        setAssignedChannels([])
        fetchAssignedChannels();
        }
      else if (activeTab === 'tab2'){
        setArchivedChannels([]);
        fetchArchivedChannels();
      }
    },
    onChannelChanged: () => {
      if (activeTab === 'tab0') fetchPracticeChannels();
      else if (activeTab === 'tab1') fetchAssignedChannels();
      else if (activeTab === 'tab2') fetchArchivedChannels();
    },
  });

  //sdk?.groupChannel.addGroupChannelHandler('channelList_care', handler);
  var handlerID = "channelList_care";
  sendbird?.groupChannel?.addGroupChannelHandler(handlerID, channelHandler);
};

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchButtonClick = () => {
    setSearchQuery(searchQuery.trimStart());
        saveFilterState(searchQuery.trimStart());
    
    if (searchQuery.trimStart().length > 0) {
      if (activeTab === 'tab0') fetchPracticeChannels(searchQuery);
      else if (activeTab === 'tab1') fetchAssignedChannels(searchQuery);
      else if (activeTab === 'tab2') fetchArchivedChannels(searchQuery);
    } else {
      setSearchQuery("");
     if (activeTab === 'tab0') fetchPracticeChannels();
      else if (activeTab === 'tab1') fetchAssignedChannels();
      else if (activeTab === 'tab2') fetchArchivedChannels();
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    //setChannelList([]);
    if (activeTab === 'tab0') await fetchPracticeChannels();
      else if (activeTab === 'tab1') await fetchAssignedChannels();
      else if (activeTab === 'tab2') await fetchArchivedChannels();
    handleClose();
  }

  const fetchArchivedChannels = async (searchKey = null,filterBy_location=null,filterBy_Team=null) => {
    setLoading(true);
    try {
      let sendbird = sdk;
      let params = {
        limit: limit,
        hiddenChannelFilter: HiddenChannelFilter.HIDDEN,
        customTypesFilter:['DPCDoctor','Teams','Provider','Nonprovider'],
      };
      if (searchKey && searchKey.length > 0) {
        params.nicknameContainsFilter = searchKey
      }
      if(filterBy_location && filterBy_location.length>0){
        params.metadataKey='location';
        params.metadataValues=filterBy_location;
      }
      if(filterBy_Team){
        params.metadataKey='team';
        params.metadataValues=[filterBy_Team];
      }
      const query = sendbird.groupChannel.createMyGroupChannelListQuery(params);
      // const list = query.hasNext ? await query.next() : [];
      // setArchivedQuery(query);
      // setArchivedChannels(list);

      if (query.hasNext) {
        const fetchedArchivedChannels = await query.next();
        setQuery(query);
        setHasNext(query.hasNext);
        if (fetchedArchivedChannels.length > 0) {
          setArchivedChannels(fetchedArchivedChannels);
          setLoading(false);
        } else {
          setArchivedChannels([]);
          setLoading(false);
        }
      } else {
        setArchivedChannels([]);
        setLoading(false);
      }
  } catch (e) {
    console.error(e);
  } finally {
    setLoading(false);
  }
  }

  const fetchPracticeChannels = async (searchKey = null,filterBy_location=null,filterBy_Team=null) => {
    setLoading(true);
    try {
    let sendbird = sdk;
    let params = {
      limit: limit,
      customTypesFilter:['DPCDoctor','Teams','Provider','Nonprovider'],
    };
    if (searchKey && searchKey.length > 0) {
      params.nicknameContainsFilter = searchKey;
    }
    if(filterBy_location && filterBy_location.length>0){
      params.metadataKey='location';
      params.metadataValues=filterBy_location;
    }
    if(filterBy_Team){
      params.metadataKey='team';
      params.metadataValues=[filterBy_Team];
    }
    if (!filterBy_Team && !filterBy_location) {
      params.order= "latest_last_message"
    }
    let query = sendbird.groupChannel.createMyGroupChannelListQuery(params);
   
    // const list = query.hasNext ? await query.next() : [];
    // setPracticeQuery(query);
    // setPracticeChannels(list);
    
    if (query.hasNext) {
      const fetchedChannels = await query.next();
      setQuery(query);
      setHasNext(query.hasNext);
      if (fetchedChannels.length > 0) {
        setPracticeChannels(fetchedChannels);
        setLoading(false);
      } else {
        setPracticeChannels([]);
        setLoading(false);
      }
    } else {
      setPracticeChannels([]);
      setLoading(false);
    }

  } catch (e) {
    console.error(e);
  } finally {
    setLoading(false);
  }
  };

 const fetchAssignedChannels = async (searchKey = null,filterBy_location=null,filterBy_Team=null) => {

  await providersAssignChat(doctorDetails.data.id).then(async (e)=>{
  setLoading(true);
    try {
    let sendbird = sdk;
    let params = {
    limit: limit,
    customTypesFilter:['DPCDoctor'],
    order: 'latest_last_message',
   };
      if (e.data.data.length > 0) {
        params.userIdsFilter = {
          userIds: e.data.data,
          includeMode: true,
          queryType:QueryType.OR,
        }
    }
    if (searchKey && searchKey.length > 0) {
      params.nicknameContainsFilter = searchKey;
    }
    if(filterBy_location && filterBy_location.length>0){
      params.metadataKey='location';
      params.metadataValues=filterBy_location;
    }
    if(filterBy_Team){
      params.metadataKey='team';
      params.metadataValues=[filterBy_Team];
    }
    if (!filterBy_Team && !filterBy_location) {
      params.order= "latest_last_message"
    }
    let query = sendbird.groupChannel.createMyGroupChannelListQuery(params);
    // const list = query.hasNext ? await query.next() : [];
    // setAssignedQuery(query);
    // setAssignedChannels(list);
    if (query.hasNext) {
      const fetchedAssignedChannels = await query.next();
      setQuery(query);
      setHasNext(query.hasNext);
     
      if (fetchedAssignedChannels.length > 0) {
        const filterList=fetchedAssignedChannels.filter((x) => x.data && parseDataForTab1(x))
        setAssignedChannels(filterList);
        setLoading(false);
      } else {
        setAssignedChannels([]);
        setLoading(false);
      }
    } else {
      setAssignedChannels([]);
      setLoading(false);
    }
  } catch (e) {
    console.error(e);
  } finally {
    setLoading(false);
  }
 });
  };

  const onChangePage = async (page) => {
    setCurrentPage(page);
    if(currentPage < page && query.hasNext) {
      setLoading(true);
      var nextQuery = query
      if (nextQuery.hasNext) {
        var fetchedChannels = await nextQuery.next();
        if (fetchedChannels.length > 0) {
          if(activeTab ==='tab0'){
            setPracticeChannels([...practiceChannels,...fetchedChannels]);
            console.log(practiceChannels)
          }
          if(activeTab ==='tab1'){
            setAssignedChannels([...assignedChannels,...fetchedChannels])
          }
          if(activeTab ==='tab2'){
            setArchivedChannels([...archivedChannels,...fetchedChannels])
          }
          setQuery(nextQuery);
          setLoading(false);
          setHasNext(query.hasNext);
        }
        else {
          setHasNext(false);
          setLoading(false)
        }
      } else {
        setLoading(false);
      }
    } else if(currentPage > page) {
      setHasNext(true);
    } else if((activeTab === 'tab0' && ((page*limit) === practiceChannels.length)) || (activeTab === 'tab1' && ((page*limit) === assignedChannels.length)) || (activeTab === 'tab2' && ((page*limit) === archivedChannels.length))) 
    {
      setHasNext(false);
    } else{
      setHasNext(true);
    }
  };
  

  const moveToPractice = async (item) => {
    setLoading(true);
    onMoveToPractice(item,doctorDetails,()=>{
      handleUpdate();
    })
  };
 
  const saveFilterState = (searchValue = searchQuery) => {
    const filterDataToSave = {
      locations: selectedLocations,
      team: selectedTeam,
      search: searchValue,
      activeTab: activeTab
    };
    dispatch(getChatFilterData(filterDataToSave));
  };

  const handleTeamChange = (event) => {
    setSelectedTeam(event.target.value);
    setSelectedLocations([]); // Reset locations when a new team is selected
    setPatientFilterval({ team: event.target.value, locations:[] })
    
    saveFilterState();
    
  if (activeTab === 'tab0') fetchPracticeChannels(null, null ,event.target.value.toString());
  else if (activeTab === 'tab1') fetchAssignedChannels(null, null ,event.target.value.toString());
  else if (activeTab === 'tab2') fetchArchivedChannels(null, null ,event.target.value.toString());
  
  }

  const handleMultiLocations = (selectedIds) => {
    setSelectedLocations(selectedIds); // Update locations
    setSelectedTeam(""); // Reset team when locations are selected
    setPatientFilterval({ team: '' , locations: selectedIds});
    
    saveFilterState();
    
    const convertingIDtoString = selectedIds.map(id => id.toString());  
  if (activeTab === 'tab0') fetchPracticeChannels(null, convertingIDtoString ,null);
  else if (activeTab === 'tab1') fetchAssignedChannels(null, convertingIDtoString ,null);
  else if (activeTab === 'tab2') fetchArchivedChannels(null, convertingIDtoString ,null);
  
  };

  const parseDataForTab0 = (x) => {
    try {
      const parsed = JSON.parse(x.data);
      return parsed?.AssignedTo !== doctorDetails.data.doctor_login.sendbird_user_id
    }
    catch (e) {
      return x.data !== doctorDetails.data.doctor_login.sendbird_user_id
    }
  }
  const parseDataForTab1 = (x) => {
    try {
      const parsed = JSON.parse(x.data);
      return parsed?.AssignedTo == doctorDetails.data.doctor_login.sendbird_user_id
    }
    catch (e) {
      return x.data == doctorDetails.data.doctor_login.sendbird_user_id
    }
  }
  const placeholderText = {
    tab0: "Search Patients and Provider in Practice",
    tab1: "Search Patients Assigned",
    tab2: "Search Patients and Provider in Archived"
  };
  const handleChannelClick = (channel) => {
    dispatch(toggleChatDetail(true));
    handleChatView(channel);
  };

  const renderListItem = () => {
    const index = (currentPage-1)*limit;

    const itemList = activeTab === 'tab0'
    ? [...practiceChannels]
    : activeTab === 'tab1'
    ? [...assignedChannels]
    : [...archivedChannels];   

    const spliceList = itemList.splice(index, limit);
    const filterList = activeTab === 'tab0' && spliceList && spliceList.length > 0 ? spliceList.filter((x) => x.data == "" || parseDataForTab0(x)): 
    activeTab === 'tab1' && spliceList && spliceList.length > 0 ? spliceList.filter((x) => x.data && parseDataForTab1(x)) :  
    spliceList;
    return ( filterList && filterList.length > 0 && !loading ? (filterList.map((item, index) => {return(
        <ChanneLItemPreview  activeTab={activeTab} scheduledMessageList={scheduledMessageList} isMoveToPractice={activeTab === 'tab1'} moveToPractice={(item)=>moveToPractice(item)} item={item} key={index} onClick={handleChannelClick} currentUser={currentUser}/>
      )})
      ) : !loading && activeTab !== "tab3" ? (
        <p className="flex-1 w-full h-1/2 flex justify-center items-center text-base text-gray-500">
          {activeTab === "tab2" ? "No Archived Conversation" : "No Conversation"}
        </p>) : null)
  }

  if (isRestoringFilters) {
    return (
      <div className="w-full p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700 flex items-center justify-center" style={{ minHeight: '400px' }}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="w-full p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">
         {
        //  ((activeTab === "tab0" && channelList && channelList.length > 0 && channelList.filter((x) => x.data === "" || x.data !== doctorDetails.data.doctor_login.sendbird_user_id).length > 0 && !loading) ||
        //  (activeTab === "tab1" && (channelList && channelList.length > 0 && channelList.filter((x) => x.data && x.data === doctorDetails.data.doctor_login.sendbird_user_id).length > 0) && !loading) || 
        //  (activeTab === 'tab2' && archiveChannelList && archiveChannelList.length > 0 && !loading)) &&
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mb-3 items-end">
        {Patientfilter?.locations &&
          <div className="relative z-10 sm:col-span-1 mb-5 me-0 sm:me-5 lg:mb-0">
            <label htmlFor="standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-everglade-600 peer-focus:dark:text-everglade-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">
              Locations
            </label>
            <MultiSelect key={`locations-${selectedLocations.join('-')}`} component="Locations" options={Patientfilter.locations}  selectedValues={selectedLocations} property={'location_name'} handleSelection={handleMultiLocations} />
          </div>}
        {Patientfilter?.teams && <div className="relative z-0 sm:col-span-1 mb-5 me-0 lg:me-5 lg:mb-0">
          <label htmlFor="standard" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-everglade-600 peer-focus:dark:text-everglade-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto">
            Team
          </label>
          <select id="standard" value={selectedTeam} onChange={handleTeamChange} className="block rounded-t-lg px-2.5 pb-2.5 pt-5 w-full text-sm text-gray-900 border-0 border-b-2 border-everglade-900 appearance-none dark:text-white dark:border-everglade-600 dark:focus:border-everglade-500 focus:outline-none focus:ring-0 focus:border-everglade-600 peer bg-transparent" placeholder=" ">
            <option key="Team" value="" className="whitespace-normal md:whitespace-nowrap">{'Please Select Team'}</option>
            {Patientfilter.teams.map((e) => (
              e.tname && <option key={e.id} value={e.id}>{e.tname}</option>
            ))}
          </select>
        </div>
        }
         <div className="relative sm:col-span-2 mb-5 me-0 lg:mb-0">
        {
        // ((activeTab === "tab0" && channelList && channelList.length > 0 && channelList.filter((x) => x.data === "" || x.data !== doctorDetails.data.doctor_login.sendbird_user_id).length > 0 && !loading) ||
        //  (activeTab === "tab1" && (channelList && channelList.length > 0 && channelList.filter((x) => x.data && x.data === doctorDetails.data.doctor_login.sendbird_user_id).length > 0) && !loading) || 
        //  (activeTab === 'tab2' && archiveChannelList && archiveChannelList.length > 0 && !loading)) &&
          <div className="relative">
            <input
              type="text"
              placeholder={placeholderText[activeTab] || "Search"}
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleSearchButtonClick();
                }
              }}
              className="w-full py-2 px-2 rounded-lg border border-gray-300 pr-24 focus:border-everglade-500 focus:outline-none focus:ring-everglade-500"
            />
            <button
              onClick={handleSearchButtonClick}
              className="absolute top-1/2 right-[0.1rem] transform translate-y-[-50%] p-2 bg-everglade-800 rounded-lg hover:bg-everglade-500"
            >
                <Icon icon={"icon-park-outline:find"} className="text-white"  />
            </button>
          </div>
          }
        </div>
      </div>}
     
     
          {activeTab === "tab3" && <ChatHistory/>}
        <div className="flow-root p-3 px-0">
            {activeTab === "tab2" && archivedChannels && archivedChannels.length > 0 && !loading ? renderListItem()
              : activeTab === "tab1" && assignedChannels && assignedChannels.length > 0 && !loading ? renderListItem() 
              : activeTab === "tab0" && practiceChannels && practiceChannels.length > 0 && !loading ? renderListItem()
              : loading ? (
              <section className="flex-1 w-full h-1/2 flex justify-center items-center">
                <Spinner />
              </section>
              ) : !loading&& activeTab !== "tab3" ? (
              <p className="flex-1 w-full h-1/2 flex justify-center items-center text-base text-gray-500">
                {activeTab === "tab2" ? "No Archived Conversation" : "No Conversation"}
              </p>
            ) : null}
        </div>
        <div className='my-3 flex  justify-center pr-4 w-full md:justify-end'>
        {assignedChannels.filter((x) => x.data === doctorDetails.data.doctor_login.sendbird_user_id)} 
        {
        activeTab === "tab0" && practiceChannels && practiceChannels.length > 0 && practiceChannels.filter((x) => x.data === "" || x.data !== doctorDetails.data.doctor_login.sendbird_user_id).length > 0 && !loading ? 
          <ChatPagination hasNext={hasNext} page={currentPage} onChange={(page)=> onChangePage(page)} /> : 
        activeTab === "tab1" && (assignedChannels && assignedChannels.length > 0 ) && !loading ? 
          <ChatPagination hasNext={hasNext} page={currentPage} onChange={(page)=> onChangePage(page)} /> :
        activeTab === "tab2" && archivedChannels && archivedChannels.length > 0 && !loading ? 
          <ChatPagination hasNext={hasNext} page={currentPage} onChange={(page)=> onChangePage(page)}/> 
        : null}
      </div>
    </div>
  );
};

export default ChanneListPreview;